<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}" style="z-index: 1050;">
    <a class="close" (click)="removeAlert(alert)">&times;</a>
    <span [innerHTML]="alert.message"></span>
</div>